import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <g>
      <path d="M16,32 C7.163444,32 1.082166e-15,24.836556 0,16 C-1.082166e-15,7.163444 7.163444,1.623249e-15 16,0 C24.836556,-1.623249e-15 32,7.163444 32,16 L30,16 C30,8.2680135 23.7319865,2 16,2 C8.2680135,2 2,8.2680135 2,16 C2,23.7319865 8.2680135,30 16,30 L16,32 Z"/>
      <polygon className="euiIcon__fillSecondary" points="23 15 17 15 17 9 15 9 15 15 9 15 9 17 15 17 15 23 17 23 17 17 23 17"/>
      <rect className="euiIcon__fillSecondary" width="2" height="7" x="20" y="25"/>
      <rect className="euiIcon__fillSecondary" width="2" height="12" x="25" y="20"/>
      <rect className="euiIcon__fillSecondary" width="2" height="9" x="30" y="23"/>
    </g>
  </svg>
);
